module.exports = __webpack_public_path__ + "img/ry_banner_tr.270eb4a5.png";